
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[restaurant]/[orderType]",
      function () {
        return require("private-next-pages/[restaurant]/[orderType]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[restaurant]/[orderType]"])
      });
    }
  